require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./custom-ubuntu-live-cd.json") })
        }
      }, "path---custom-ubuntu-live-cd");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---custom-ubuntu-live-cd!./.cache/json/custom-ubuntu-live-cd.json
// module id = 494
// module chunks = 231608221292675